// src/components/ImageUploader.js
import React, { useState } from "react";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage, auth } from "../firebase";
import { getIdTokenResult } from "firebase/auth";

// Normalise un nom de fichier: supprime accents/espaces/apostrophes typographiques
function sanitizeName(name) {
  const base = name.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // accents -> ASCII
  return base
    .replace(/[’'"]/g, "")        // apostrophes & guillemets
    .replace(/[^a-zA-Z0-9._-]+/g, "_") // autres caractères spéciaux -> _
    .replace(/_+/g, "_")
    .trim();
}

export default function ImageUploader({ onUploaded, pathPrefix = "uploads/products" }) {
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState("");

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // 1) Vérifier l’auth & le claim admin (avec refresh token)
    const user = auth.currentUser;
    if (!user) {
      alert("Vous devez être connecté en admin pour téléverser.");
      return;
    }
    const tokenRes = await getIdTokenResult(user, true); // force refresh
    if (!tokenRes.claims?.admin) {
      alert("Accès refusé : votre compte n'a pas le rôle admin.");
      return;
    }

    setLoading(true);
    try {
      const safe = sanitizeName(file.name);
      const path = `${pathPrefix}/${Date.now()}_${safe}`;
      const storageRef = ref(storage, path);
      await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(storageRef);
      setUrl(downloadURL);
      onUploaded && onUploaded(downloadURL);
    } catch (err) {
      console.error(err);
      alert("Échec de l'upload : " + (err?.message || "inconnu"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <input type="file" className="form-control" onChange={onFile} accept="image/*" />
      {loading && <div className="form-text">Téléversement…</div>}
      {url && (
        <div className="mt-2">
          <img src={url} alt="preview" style={{ maxWidth: 180, borderRadius: 8 }} />
        </div>
      )}
    </div>
  );
}
